import { Link } from "@/i18n/navigation"

export const CoverLink = ({ href }: { href?: string }) =>
  href ? <Link href={href} data-cover-link aria-hidden tabIndex={-1} prefetch={false} className="absolute inset-0 block" /> : null
